<template>
  <div class="brief-usuarios">
    <b-card header= "Usuarios" class="brief-header">
      <b-btn class="btn-collapse-card" 
          variant="primary" 
          size="sm"
          @click.prevent="showUsuarios= !showUsuarios">
        <i :class="showUsuarios ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="headerUsuarios" class="mt-2" v-model="showUsuarios">
        <b-row>
          <b-col>
            <b-form-group
              label="Creado por"
              label-for="usuario"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="usuario"
                :value="usuario"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Responsable"
              label-for="responsable"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="responsable"
                :value="responsable"
                readonly
                type="text"/>
            </b-form-group>

            <b-table hover
                responsive="sm" 
                class="registro"
                :items="usuarios" 
                :fields="usuariosFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(usuario)="data">
                {{ data.item.usuario.trim() + ' - ' + data.item.usuarioRol.trim() }}
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'briefDatos/getField',
  mutationType: 'briefDatos/updateField',
});

export default {
  name: 'BriefUsuariosData',
  data () {
    return {
      usuariosFields: [
        {
          key: 'usuario',
          label: 'Usuarios',
        },
      ],

      showUsuarios: false,

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'usuario',
      'responsable',
      'usuarios',
    ]),
  },  
  created() {
  },
  destroyed() {
  },
}
</script>

<style>
  .brief-usuarios .registro {
    margin-top: 30px;    
  }
  .brief-usuarios table thead th {
    border-top: none;
  }
  .brief-usuarios table tr.table-inactivo {
    color: #a9a9a9;
  }
</style>